import { borderRadius as defaultBorderRadius } from "gatsby-theme-wild-child/src/@chakra-ui/gatsby-plugin/foundations/borderRadius.js"

export const borderRadius = {
  ...defaultBorderRadius,
}
